export default function truncateText(text, len) {
  if (!text) return '';
  if (text.length > len) {
    return `${text.slice(0, len)}...`;
  }
  return text;
}
